import { IComboBoxOption } from "@fluentui/react";
import { List } from "linq.ts";

export enum PermissionLevel {
    none = 0,
    owner = 1,
    reader = 2,
    contributor = 3
}

export const GetPermissionLevelString = (permissionLevel: PermissionLevel): string => {
    switch (permissionLevel) {
        case PermissionLevel.none: return 'None';
        case PermissionLevel.owner: return 'Owner';
        case PermissionLevel.reader: return 'Reader';
        case PermissionLevel.contributor: return 'Contibutor';
        default: return 'Not supported';
    }
}

export const PermissionLevelDataSource: IComboBoxOption[] = new List<IComboBoxOption>([
    { key: PermissionLevel.owner, text: GetPermissionLevelString(PermissionLevel.owner) },
    { key: PermissionLevel.reader, text: GetPermissionLevelString(PermissionLevel.reader) },
    { key: PermissionLevel.contributor, text: GetPermissionLevelString(PermissionLevel.contributor) }
]).OrderBy(x => x.text).ToArray();
